/* bs-spin: a pinned section that turns the product as the visitor scrolls (sections/bs-spin.liquid).
   Frames are a numbered image sequence in Shopify Files. Loading: frame 1 first, then a coarse pass (every 32nd frame),
   then finer passes down to every frame, so a fast scroller always has a nearby frame to draw. Phones get 720 px frames
   from the CDN; Save-Data gets every 4th frame. Drawing: the scroll position sets a target frame and the drawn frame
   eases toward it on each animation frame, then stops. Captions are text in the page, faded in and out by frame range.
   On a product page with an Elite/Basic toggle the sequence follows the visible version. */
(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-bs-spin]');
  if (!roots.length) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function pad(i) { return ('00' + i).slice(-3); }
  function order(n) {
    var seen = {}, out = [0];
    seen[0] = 1;
    [32, 16, 8, 4, 2, 1].forEach(function (step) {
      if (saveData && step < 4) return;
      for (var i = 0; i < n; i += step) if (!seen[i]) { seen[i] = 1; out.push(i); }
    });
    return out;
  }
  function visibleVersion() {
    var v = document.querySelector('.bs-pdp-ver:not([hidden])');
    return v ? (v.getAttribute('data-ver') || '0') : '0';
  }

  roots.forEach(function (root) {
    var sets = JSON.parse(root.getAttribute('data-sets'));
    var beats = [].slice.call(root.querySelectorAll('[data-beat]'));
    var stage = root.querySelector('.bs-spin-stage');
    var canvas = root.querySelector('.bs-spin-canvas');
    var hint = root.querySelector('.bs-spin-hint');
    var ver = visibleVersion();

    function applyVersion() {
      beats.forEach(function (b) { var v = b.getAttribute('data-ver'); b.hidden = !(v === 'all' || v === ver); });
    }
    applyVersion();

    if (reduce || !canvas.getContext) return;   /* stays in its static form: first frame, captions as a list */
    root.classList.remove('is-static');
    var ctx = canvas.getContext('2d');
    var cache = {};           /* key -> array of Image (loaded) or null */
    var queue = [], inflight = 0, started = false;
    var target = 0, current = 0, raf = 0, lastDrawn = -1, lastKey = '';

    function setKey() { return ver in sets ? ver : '0'; }
    function frameUrl(set, i) {
      var url = set.base + pad(i + 1) + '.webp';
      return window.innerWidth < 900 ? url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=720' : url;
    }
    function enqueue(key) {
      var set = sets[key], frames = cache[key] || (cache[key] = new Array(set.n));
      order(set.n).forEach(function (i) { if (!frames[i]) queue.push([key, i]); });
      pump();
    }
    function pump() {
      while (inflight < 6 && queue.length) {
        var job = queue.shift(), key = job[0], i = job[1], frames = cache[key];
        if (frames[i]) continue;
        frames[i] = 'loading'; inflight++;
        (function (key, i) {
          var img = new Image();
          img.decoding = 'async';
          img.onload = function () {
            var done = function () { cache[key][i] = img; inflight--; pump(); if (key === setKey()) schedule(true); };
            img.decode ? img.decode().then(done, done) : done();
          };
          img.onerror = function () { cache[key][i] = null; inflight--; pump(); };
          img.src = frameUrl(sets[key], i);
        })(key, i);
      }
    }
    function nearest(frames, i) {
      for (var d = 0; d < frames.length; d++) {
        var a = frames[i - d], b = frames[i + d];
        if (a && a !== 'loading') return a;
        if (b && b !== 'loading') return b;
      }
      return null;
    }

    /* Layout, in CSS pixels, worked out from the real caption sizes so the two never collide.
       Wide screens: captions in a left column, the product in the space to its right.
       Phones: the product and the caption are one group, centred in the screen below the header. */
    var layout = [0, 0, 0, 0];
    function headerHeight() {
      var h = document.querySelector('sticky-header, .section-header, header');
      var r = h ? h.getBoundingClientRect() : null;
      return r && r.bottom > 0 && r.bottom < 160 ? r.bottom : 0;
    }
    function measure() {
      var w = stage.clientWidth, h = stage.clientHeight, set = sets[setKey()], aspect = set.w / set.h;
      var shown = beats.filter(function (b) { return !b.hidden; });
      if (w >= 900) {
        var right = 0, sr = stage.getBoundingClientRect();
        shown.forEach(function (b) { right = Math.max(right, b.getBoundingClientRect().right - sr.left); });
        var x = right + Math.max(40, w * 0.03), pad = Math.max(24, w * 0.03);
        var bw = Math.max(200, w - x - pad), top = headerHeight();
        var bh = Math.min((h - top) * 0.84, bw / aspect);
        layout = [x, top + (h - top - bh) / 2, bw, bh];
      } else {
        var capH = 0;
        shown.forEach(function (b) { capH = Math.max(capH, b.offsetHeight); });
        var side = 12, bw2 = w - side * 2, ph = bw2 / aspect, gap = 8, head = headerHeight() || 64;
        var room = h - head - 16, group = ph + gap + capH;
        if (group > room) { ph = Math.max(140, room - gap - capH); bw2 = ph * aspect; }
        var top2 = head + Math.max(8, (room - (ph + gap + capH)) / 2);
        layout = [(w - bw2) / 2, top2, bw2, ph];
        stage.style.setProperty('--cap-top', Math.round(top2 + ph + gap) + 'px');
      }
    }
    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = stage.clientWidth, h = stage.clientHeight;
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
      measure();
      lastDrawn = -1; schedule(true);
    }
    function box() {
      var k = canvas.width / Math.max(1, stage.clientWidth);
      return [layout[0] * k, layout[1] * k, layout[2] * k, layout[3] * k];
    }
    function draw(force) {
      var key = setKey(), frames = cache[key];
      if (!frames) return;
      var i = Math.round(current);
      if (!force && i === lastDrawn && key === lastKey) return;
      var img = nearest(frames, i);
      if (!img) return;
      var b = box(), r = Math.min(b[2] / img.naturalWidth, b[3] / img.naturalHeight);
      var w = img.naturalWidth * r, h = img.naturalHeight * r;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, b[0] + (b[2] - w) / 2, b[1] + (b[3] - h) / 2, w, h);
      if (!root.classList.contains('is-live')) root.classList.add('is-live');
      lastDrawn = i; lastKey = key;
    }
    function beatsAt(f) {
      beats.forEach(function (el, k) {
        if (el.hidden) return;
        var from = +el.getAttribute('data-from'), to = +el.getAttribute('data-to'), span = Math.max(1, to - from);
        var fade = Math.max(2, span * 0.22), a;
        if (f < from || f > to) a = 0;
        else {
          var inA = from <= 1 ? 1 : Math.min(1, (f - from) / fade);
          var outA = to >= 100 ? 1 : Math.min(1, (to - f) / fade);
          a = Math.min(inA, outA);
        }
        el.style.opacity = a.toFixed(3);
        el.style.visibility = a < 0.01 ? 'hidden' : 'visible';
        var y = (1 - a) * 18;
        el.style.transform = stage.clientWidth >= 900 ? 'translateY(calc(-50% + ' + y + 'px))' : 'translateY(' + y + 'px)';
      });
    }
    /* the turn starts while the section is still coming into view (the last 60% of the screen before it pins), so the
       first scroll already moves the product instead of scrolling past a still frame (Oct 14) */
    function progress() {
      var r = root.getBoundingClientRect(), run = root.offsetHeight - window.innerHeight, lead = window.innerHeight * 0.6;
      return run > 0 ? Math.min(1, Math.max(0, (lead - r.top) / (run + lead))) : 0;
    }
    function tick() {
      raf = 0;
      var n = sets[setKey()].n, diff = target - current;
      current = Math.abs(diff) < 0.05 ? target : current + diff * 0.32;
      draw(false);
      beatsAt(current / (n - 1) * 99 + 1);
      if (current !== target) raf = requestAnimationFrame(tick);
    }
    function schedule(force) {
      if (force) lastDrawn = -1;
      if (!raf) raf = requestAnimationFrame(tick);
    }
    function onScroll() {
      var p = progress(), n = sets[setKey()].n;
      target = p * (n - 1);
      if (hint) hint.style.opacity = Math.max(0, 1 - p * 10).toFixed(2);
      schedule(false);
    }

    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && !started) { started = true; size(); enqueue(setKey()); }
      });
    }, { rootMargin: '150% 0px' });
    io.observe(root);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { if (started) { size(); onScroll(); } });

    /* the Elite/Basic toggle on the product page */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-ver-pick]')) return;
      setTimeout(function () {
        var v = visibleVersion();
        if (v === ver) return;
        ver = v; applyVersion(); if (started) measure();
        if (started) { enqueue(setKey()); }
        onScroll(); schedule(true);
      }, 0);
    });
    onScroll();
  });
})();
